import React from "react";
import { useImageWithAuth } from "../../../../hooks/useImageWithAuth";

interface ImageWithAuthProps {
  alt?: string;
  src?: string;
  title?: string;
  style?: React.CSSProperties;
  className?: string;
  placeholderClassName?: string;
}

export const ImageWithAuth: React.FC<ImageWithAuthProps> = React.memo(({ 
  alt, 
  src, 
  title, 
  style, 
  className,
}) => {
  const imageSrc = useImageWithAuth(src);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    // Reset states when source changes
    setLoading(true);
    setError(false);
    
    if (!imageSrc) {
      setLoading(false);
      return;
    }

    const img = new Image();
    img.src = imageSrc;
    img.onload = () => setLoading(false);
    img.onerror = () => {
      console.error(`Failed to load image: ${src || 'unknown source'}`);
      setError(true);
      setLoading(false);
    };

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [imageSrc, src]);

  if (loading) {
    return null;
  }

  if (error || !imageSrc) {
    return null;
  }

  return <img alt={alt} src={imageSrc} title={title} style={style} className={className} />;
});